import React from "react";
import Layout from "../components/Layout";

export default function DataAnalyticsPage() {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-text">
          <h1>Data Analytics</h1>
          <p>
            Decode your data and find hidden insights to boost your business.
          </p>
        </div>
        <div className="hero-visuals">
          <img
            src="/assets/images/dataAnalytics.png"
            alt="DataAnalytics visual"
          />
        </div>
      </section>

      {/* What do the numbers mean */}
      <section className="intro-section">
        <h2>What do the numbers mean?</h2>
        <p>
          The operations of businesses can generate gigabytes, sometimes even terabytes, of data. Sorting through this data can be incredibly daunting, especially if the data isn't organized in a way that makes it easy to understand.
        </p>
        <p>
          Fortunately, at TearabyteSS, we specialize in delving into this data labyrinth. Our expertise lies in uncovering concealed trends within your data, providing opportunities for your business to capitalize on them effectively.
        </p>
      </section>

      {/* Manual Statistical Analysis */}
      <section className="split-section">
        <div className="split-image">
          <img
            src="/assets/images/demoGraph.png"
            alt="Demo graph example"
          />
        </div>
        <div className="split-text">
          <h3>Manual Statistical Analysis</h3>
          <p>
            Our team of data analysts use rigorous statistical methods to uncover trends in your data. Techniques we apply include:
          </p>
          <ul>
            <li>Regression analysis</li>
            <li>Time series analysis</li>
            <li>Cluster analysis</li>
            <li>Factor analysis</li>
            <li>Principal component analysis</li>
          </ul>
        </div>
      </section>

      {/* Machine Learning */}
      <section className="split-section reverse">
        <div className="split-image">
          <img
            src="/assets/images/neuralNet.png"
            alt="Neural network illustration"
          />
        </div>
        <div className="split-text">
          <h3>Machine Learning Analysis</h3>
          <p>
            Sometimes, trends are too complex for traditional methods. In these cases, we turn to machine learning to uncover hidden insights. Techniques we use include:
          </p>
          <ul>
            <li>Linear regression</li>
            <li>Logistic regression</li>
            <li>Decision trees</li>
            <li>Random forests</li>
            <li>Neural networks</li>
          </ul>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="contact-cta">
        <h2>Interested? Contact us for a quote!</h2>
        <a className="contactLink" href="/contact">
          Contact Us
        </a>
      </section>
    </Layout>
  );
}
